/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { Record } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'

const MonthlyTransactionState = Record({
  id: null
})

class MonthlyTransactionStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new MonthlyTransactionState()
  }

  reduce(state, action) {
    switch (action.type) {
      default:
        return state
    }
  }
}
export default new MonthlyTransactionStore()
